import { putData } from 'helpers/RequestHelper';

export const updatePhoneNumber = (ssn, phoneNumber) => {
  return putData({
    url: '/auth/login/mfa/update_phone',
    body: {
      ssn,
      phone_number: phoneNumber
    }
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data);
};
